import { actionCreator,
  checkHttpStatus,
  create_post_data,
  createRequestActionTypes,
  createSearchUrl,
  extractDataFromObject,
  handleFirstLoginAfterSignUp,
  handleLoginRedirect,
  handleLogoutRedirect,
  handleRefreshTokenRedirect,
  handleSecurityQuestionRedirect,
  jsonApiHeader,
  showSuccessMessage,
  jsonApiHeaderBusinessName,
} from './../../../actions/utilAction';
import { API_URL } from '../../../actions/utilAction';
export { jsonApiHeader,
  actionCreator,
  checkHttpStatus,
  createSearchUrl,
  create_post_data,
  showSuccessMessage,
  extractDataFromObject,
  handleFirstLoginAfterSignUp,
  handleLoginRedirect,
  handleLogoutRedirect,
  handleRefreshTokenRedirect,
  handleSecurityQuestionRedirect,
  jsonApiHeaderBusinessName,
};

export const BUSINESS_NAME_API = `${API_URL}/VerifyBusinessName`;
// export const LOGIN_API = `${API_URL}/authentication/login`;//json
export const LOGIN_API = `${API_URL}/Login/login`;
export const LOGOUT_API = `${API_URL}/Login/Logout`;
export const FORCED_LOGOUT_API = `${API_URL}/Login/ForcedLogout`;
export const FORGOT_PASSWORD_API = `${API_URL}/ForgotPassword`;
export const REFRESH_TOKEN = `${API_URL}/GetUserByToken`;
export const RESET_PASSWORD_API = `${API_URL}/ResetPassword`;
export const USERASSIGNEDLOCATIONS = `${API_URL}/GetUserAssignedLocations`;
export const UPDATE_LOGIN_PASSWORD_API = `${API_URL}/User/UpdateExpiredPassword`;
export const CHECK_RESET_PASSWORD_LINK_IS_VALID = `${API_URL}/CheckResetPasswordLinkIsValid`;


export const loginActionTypes = {
  check_business_name: createRequestActionTypes('CHECK_BUSINESS_NAME'),
  post_login: createRequestActionTypes('POST_LOGIN'),
  post_forgotPassword: createRequestActionTypes('POST_FOTGOT_PASSWORD'),
  logout_user: createRequestActionTypes('LOGOUT_USER'),
  forced_logout_user: createRequestActionTypes('FORCED_LOGOUT_USER'),
  refresh_token: createRequestActionTypes('REFRESH_TOKEN'),
  post_resetPassword: createRequestActionTypes('POST_RESET_PASSWORD'),
  get_login_questions: createRequestActionTypes('GET_LOGIN_QUESTIONS'),
  get_user_Assigned_locations: createRequestActionTypes('GET_USER_ASSIGNED_LOCATION_MASTER'),
  update_loginUserPassword: createRequestActionTypes('UPDATE_LOGINUSERPASSWORD'),
  get_resetPasswordLinkIsValid: createRequestActionTypes('CHECK_RESET_PASSWORD_LINK_IS_VALID'),
};



// WEBPACK FOOTER //
// ./src/modules/logins/constants/ApiConstants.js